export const GET_MESSAGING_SERVICE = "GET_MESSAGING_SERVICE";
export const GET_MESSAGING_SERVICE_SUCCESS = "GET_MESSAGING_SERVICE_SUCCESS";
export const GET_MESSAGING_SERVICE_ERROR = "GET_MESSAGING_SERVICE_ERROR";

export const getMessagingService = (flux, code) => {
  return {
    type: GET_MESSAGING_SERVICE,
    flux,
    code,
  };
};

export const getMessagingServiceSuccess = (messages) => {
  return {
    type: GET_MESSAGING_SERVICE_SUCCESS,
    messages,
  };
};

export const getMessagingServiceError = (e) => {
  return {
    type: GET_MESSAGING_SERVICE_ERROR,
    error: e instanceof Error ? e.message : String(e).toString() || "",
  };
};
